import React from 'react';

import adrian from './assets/adrian.png';
import helena from './assets/helena.png';
import zoe from './assets/zoe.png';
import david60 from './assets/david60.png';
import dawid from './assets/dawid.png';

export const authors = {
  adrian: {
    name: 'Adrian',
    avatar: adrian,
    description: (
      <>
        <p>Has a background in software engineering and management. His passion for creating fun and challenging games was inspired by his own experiences and drive to create the type of games he would like to play. His skills are invaluable to our company but, when he does take some down time, mountain biking is his passion.</p>
      </>
    )
  },
  helena: {
    name: 'Helena',
    avatar: helena,
    description: (
      <>
        <p>While she may work in finance her passions lie with psychology, a subject she hopes will influence her contribution to our company. Late to the gaming world, she has embraced it wholeheartedly, which is just as well since her fiancé is Lee.</p>
      </>
    )
  },
  zoe: {
    name: 'Zoe',
    avatar: zoe,
    description: (
      <>
        <p>Our intern, who is a University student from France studying International Trade. She is hoping to bring her knowledge in this area to our company and we're sure she will do great! Zoé also has an interest in fashion and loves to travel (which she hopes to get back to once things return to normal).</p>
      </>
    )
  },
  david60: {
    name: 'David Evans',
    avatar: david60,
    description: (
      <>
        <p>David Evans is a freelance writer covering topics on interactive games and entertainment. He writes to share knowledge with companies and individuals about how games can help with self improvement and team building.</p>
      </>
    )
  },
  dawid: {
    name: 'Dawid',
    avatar: dawid,
    description: (
      <>
        <p>He blends a keen understanding of the gaming industry with a flair for engaging diverse audiences. With a background in game testing, he brings a detailed eye to every project. He also dedicates time to charity gaming events, where he volunteers in marketing and sponsorship acqusition.</p>
        <p>An avid RPG enthusiast, his favorites include the intricate worlds of the 'Fallout' series, 'Skyrim,' and 'Mount & Blade: Warband'. This passion for immersive storytelling extends into his love for board games and tabletop RPGs, often enjoyed in the company of his fiancé. He loves music and grabs any instrument in sight, though he admits to not playing any of them particularly well.</p>
      </>
    )
  }
};
